import React, { useContext, useState, useEffect } from "react";
import Select from "react-select";
import { Box, VStack, Heading } from "@chakra-ui/react";
import LabeledText from "../../Common/Layout/LabeledText";
import ContentCard from "../../Common/Layout/ContentCard";
import { UsersContext } from "../../Context/UsersContext";
import { arrayToOption } from "../../../Utils/formatUtils";

const NewClientData = ({ setClient }) => {
  const { users, getUsers } = useContext(UsersContext);
  const [userOptions, setUserOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState({});

  useEffect(() => {
    getUsers({ roleId: 4, noLimit: true });
  }, []);

  useEffect(() => {
    if (users.length) {
      let parsedUsers = [...users];
      users.map((user, key) => {
        parsedUsers[key].name = user.businessName + " (" + user.id + ")";
      });
      setUserOptions(arrayToOption(parsedUsers));
    }
  }, [users]);

  const handleChange = (value) => {
    let user = users.find((u) => value.value === u.id);
    setSelectedUser(user);
    setClient(user);
  };

  return (
    <ContentCard w={["auto", "48%"]}>
      <Heading variant="h2">Cliente</Heading>
      <VStack fontSize="0.9em" align="left">
        <LabeledText
          label="Cliente"
          text={
            <Box w={["auto", "100%"]}>
              <Select
                options={userOptions}
                value={
                  selectedUser &&
                  userOptions.find((option) => option.value == selectedUser.id)
                }
                onChange={(e) => handleChange(e)}
                placeholder="Elija un cliente"
                styles={{
                  valueContainer: (provided, state) => ({
                    ...provided,
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    fontSize: "0.9rem",
                  }),
                }}
              />
            </Box>
          }
        ></LabeledText>
        {selectedUser && (
          <>
            <LabeledText
              label="Direccion"
              text={selectedUser.address}
            ></LabeledText>
            <LabeledText
              label="Dirección de envío"
              text={selectedUser.shippingAddress}
            ></LabeledText>
            <LabeledText
              label="Contacto"
              text={selectedUser.phone}
            ></LabeledText>
          </>
        )}
      </VStack>
    </ContentCard>
  );
};

export default NewClientData;
